import React from 'react';
import cl from './AboutInfo.module.css';

const AboutInfo = (props) => {
    return (
        <section className={cl.about}>
          <div className={cl.about_div}>
            <img className={cl.big_image} src='https://img.freepik.com/free-photo/people-taking-selfie-together-registration-day_23-2149096795.jpg'/>
            <div className={cl.about_ps}>
              <p className={cl.first_p_story}>{props.shopStory}</p>
            </div>
          </div>
      </section>
    );
}

export default AboutInfo;